import { useMediaQuery } from '@chakra-ui/react';
import { theme } from '../../assets/style/theme';

type Props = {
};

function LineBreakOnDesktop({  }: Props) {
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <br style={{ display: `${isMobile ? 'none' : 'inline'}` }} />
  );
}

LineBreakOnDesktop.defaultProps = {
};

export default LineBreakOnDesktop;
